import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import '../styles/mudatagridcustomstyle.css';
import axios from 'axios';
import MaterialNotifyComponent from './MaterialNotifyComponent';
import { getAuthenticationToken } from '../utils/TokenHandler';
import { Alert, Backdrop, CircularProgress, Button } from '@mui/material';
import { withRouter } from 'react-router-dom';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    defaults,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material/styles';

const columns = [
    {
        field: 'id',
        headerName: '#',
        editable: false,
    },
    {
        field: 'pointType',
        headerName: 'نوع',
        editable: false,
    },
    {
        field: 'totalPoint',
        headerName: 'امتیاز',
        editable: false,
    },
    {
        field: 'pointPersianDateTime',
        headerName: 'تاریخ',
        editable: false,
    },
];
const footerButtonStyle = {
    display: 'inline-block',
    padding: '0px 20px',
    width: '100%'
};
const formButtonElementStyle = {
    margin: "10px 0",
    backgroundColor: '#014171',
    fontSize: 'x-large',
    boxShadow: '0px 10px 20px 5px rgba(255, 255, 255, 0.2)'
};
const footerButtonContainerStyle = {
    display: 'flex',
    justifyContent: 'space-evenly',
    position: 'fixed', left: '0',
    bottom: '0', width: '100%',
    zIndex: '1'
};

const StyledDataGrid = muiStyled(DataGrid)(({ theme }) => ({
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#0072bc', // رنگ پس‌زمینه هدر
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        color: '#ffffff', // رنگ متن هدر
    },
    '& .MuiDataGrid-row:nth-of-type(odd)': {
        backgroundColor: '#0072bc', // رنگ پس‌زمینه برای سطرهای فرد
        color: '#ffffff'
    },
    '& .MuiDataGrid-row:nth-of-type(even)': {
        backgroundColor: '#ffffff', // رنگ پس‌زمینه برای سطرهای زوج
    },
    '& .MuiDataGrid-footerContainer': {
        backgroundColor: '#0072bc', // رنگ پس‌زمینه فوتر
        color: '#ffffff'
    },
    '& .MuiTablePagination-displayedRows': {
        color: '#ffffff'
    },
    '& .MuiSvgIcon-root': {
        color: '#ffffff'
    }
}));

function ScoreList(props) {
    const { history } = props
    const [customerPointHistories, setCustomerPointHistories] = useState([]);
    const [messageNotify, setMessageNotify] = useState({ severity: "error", message: "", open: false });
    const [open, setOpen] = useState(false);
    useEffect(() => {
        const url = (props.isMerchant ? 'api/v2/Dashboard/GetMerchantPointHistories' : 'api/v2/Dashboard/GetCustomerPointHistories');
        const urlParams = (props.isMerchant ? {
            params:
            {
                merchantId: getAuthenticationToken().merchantId
            }
        } : {
            params:
            {
                userId: getAuthenticationToken().userID
            }
        });
        setOpen(true);
        axios.get(url, urlParams).then((response) => {
            setCustomerPointHistories(response.data);
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در فراخوانی اطلاعات از سرور",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }, []);

    defaults.font.family = 'IRAN Sans';
    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend
    );

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    color: '#012d50', // رنگ متن لیبل‌ها
                    font:{
                        family:'YekanBakh, sans-serif',
                        weight:'bold'
                    },
                },
            },
            title: {
                display: true,
                text: props.mainTitle,
                color: '#ffffff',
                font:{
                    family:'YekanBakh, sans-serif'
                },
            },
        },
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    color: '#ffffff', // رنگ خطوط شبکه افقی
                },
                title: {
                    color: '#ffffff', // رنگ خطوط شبکه افقی
                    font:{
                        family:'YekanBakh, sans-serif'
                    },
                },
                ticks: {
                    color: '#ffffff', // رنگ خطوط شبکه افقی
                    font:{
                        family:'YekanBakh, sans-serif'
                    },
                },
            },
            y: {
                grid: {
                    color: '#ffffff', // رنگ خطوط شبکه عمودی
                },
                title: {
                    color: '#ffffff', // رنگ خطوط شبکه افقی
                    font:{
                        family:'YekanBakh, sans-serif'
                    },
                },
                ticks: {
                    color: '#ffffff', // رنگ خطوط شبکه افقی
                    font:{
                        family:'YekanBakh, sans-serif'
                    },
                },
            },
        },
    };

    const labels = customerPointHistories.map((item) => item.pointPersianDateTime)
    const data = {
        labels,
        datasets: [
            {
                label: props.mainTitle,
                data: customerPointHistories.map((item) => item.totalPoint),
                borderColor: '#012d50',
                backgroundColor: '#012d50',
            }
        ],
    };

    const ChartContainer = styled.div`
    background-color:#fff;
    border-radius:1.2rem;
    width:96%;
    height:15.5rem;
    padding:1.8rem;
    text-align:center;
    margin:10px 0;
    @media screen and (min-width: 320px) and (max-width: 1080px){
        height:max-content;
        width: 80% !important;
        margin:auto;
        margin-right:0;
        margin-top:10px;
    }
`;

    return (customerPointHistories !== null) && (
        <>
            <StyledDataGrid className={'rtl-grid'}
                style={{ margin: '20px auto', border: '0px solid rgba(255,255,255,0.0)' }}
                rows={customerPointHistories}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                direction="row-reverse"
                disableSelectionOnClick
                disableColumnMenu
                exportDataAsCsv={(e) => console.log('exportDataAsCsv', e)}
                sx={{
                    height: 900, // ارتفاع تنظیم شده
                }}
            />
            <ChartContainer
                style={{ margin: '20px auto', backgroundColor: '#0072bc' ,minHeight:'250px'}}>
                <Line options={options} data={data} />
            </ChartContainer>
            <div style={{width:'100%',height:'80px'}}></div>
            <div style={footerButtonContainerStyle}>
                <div style={footerButtonStyle}>
                    <Button
                        onClick={() => { props.history.push('/') }}
                        id="cancel"
                        name="cancel"
                        variant="contained"
                        color="success"
                        fullWidth
                        style={formButtonElementStyle}>انصراف</Button>
                </div>
            </div>
            <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default withRouter(ScoreList);